import { getDefaultRequiredValue } from "components/Form/components/SchemaForm/SchemaFormService";
import { normalizeSchemaForForm } from "components/Form/components/SchemaForm/SchemaFormInference";

/**
 * Seed the initial form values for the `run_flow_with_inputs` dashboard widget
 * from a flow's `input_schema`, applying required-field default values.
 *
 * This mirrors the seeding path the {@link SchemaForm} form-preview and
 * "run flow with options" surfaces use: those normalize the schema into the
 * form-element dialect via {@link normalizeSchemaForForm} FIRST, then derive
 * defaults with {@link getDefaultRequiredValue}. A flow's `input_schema` (and the
 * matching MCP tool `inputSchema`) is commonly written as plain JSON Schema
 * (`type`/`properties`, no `element` keys), and `getDefaultRequiredValue` only
 * applies defaults on element-annotated nodes — so seeding directly off the raw
 * schema yields `{}` and the widget's initial values diverge from the other two
 * surfaces (e.g. a required-with-default `ask` field starts uninitialised instead
 * of at its default). Normalizing first fixes that; the normalizer leaves an
 * already-dialect (or empty/non-object) schema untouched, so element-annotated
 * schemas keep seeding identically.
 */
export const seedValues = (schema: unknown): Record<string, any> => {
    if (!schema) {
        return {};
    }
    const formSchema = normalizeSchemaForForm(schema);
    return getDefaultRequiredValue(formSchema, formSchema, null) ?? {};
};
